import ko from 'knockout';
import templateMarkup from 'raw-loader!./login-container-view.html';
    function LoginContainerView(params) {
        var self = this;
        self.dataProvider = params.dataProvider;
        self.route = params.route;
    }


    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    LoginContainerView.prototype.dispose = function () { };

    export default { viewModel: LoginContainerView, template: templateMarkup };
